import { variantStyles } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

export const NoDataText = ({
  className,
  ...props
}: React.SVGProps<SVGTextElement>) => (
  <text
    style={{ transform: `translate(50%, 50%)` }}
    x={0}
    y={0}
    textAnchor="middle"
    dominantBaseline="middle"
    className={cn(variantStyles.bodySmall, className)}
    {...props}
  />
)

export const XAxisTickText = ({
  className,
  ...props
}: React.HTMLAttributes<SVGTextElement>) => (
  <text
    x={0}
    y={0}
    dy={16}
    fontSize={11}
    className={cn('fill-secondary', className)}
    textAnchor="middle"
    {...props}
  />
)
